var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "slip"
  }, [_c('div', {
    attrs: {
      "id": "printebnData"
    }
  }, [_c('head'), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('table', {
    staticClass: "table-bordered tbl datatables tableExample",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data-pdfmake": "{\"widths\":[150,200,\"*\",\"*\"],\"heights\":15}"
    }
  }, [_c('tbody', [_vm._m(0), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%",
      "border-right": "none"
    }
  }, [_c('qr-code', {
    staticStyle: {
      "margin-left": "293px"
    },
    attrs: {
      "size": 150,
      "text": _vm.ebn
    }
  })], 1)])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered tbl datatables tableExample",
    staticStyle: {
      "width": "99.4%",
      "margin-top": "3px",
      "margin-left": "3px",
      "margin-right": "3px"
    },
    attrs: {
      "data-pdfmake": "{\"widths\":[150,200,\"*\",\"*\"],\"heights\":15}"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "7%",
      "border-right": "none"
    }
  }, [_vm._v("E-Way Bill No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.ebnData.details.ewbNo))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "7%",
      "border-right": "none"
    }
  }, [_vm._v("E-Way Bill Date.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.ebnData.ewayBillDate))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "7%",
      "border-right": "none"
    }
  }, [_vm._v("Generated By:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.ebnData.details.fromGstin) + " - " + _vm._s(_vm.ebnData.details.fromTrdName))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "7%",
      "border-right": "none"
    }
  }, [_vm._v("Valid From:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.ebnData.ewayBillDate) + " [" + _vm._s(_vm.ebnData.details.actualDist) + "]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "7%",
      "border-right": "none"
    }
  }, [_vm._v("Valid Till:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.ebnData.validUpto) + " [" + _vm._s(_vm.isextended) + "]")])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "7%",
      "border-right": "none"
    }
  }, [_vm._v("GSTIN of Supplier")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.ebnData.details.fromGstin) + ", " + _vm._s(_vm.ebnData.details.fromTrdName))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "7%",
      "border-right": "none"
    }
  }, [_vm._v("Place of Dispatch")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.ebnData.details.fromPlace) + "," + _vm._s(_vm.ebnData.details.fromPlace) + " - " + _vm._s(_vm.ebnData.details.fromPincode))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "7%",
      "border-right": "none"
    }
  }, [_vm._v("GSTIN of Recipient")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.ebnData.details.toGstin) + ", " + _vm._s(_vm.ebnData.details.toTrdName))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "7%",
      "border-right": "none"
    }
  }, [_vm._v("Place of Delivery")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.ebnData.details.toPlace) + "," + _vm._s(_vm.ebnData.details.toPlace) + " - " + _vm._s(_vm.ebnData.details.toPincode))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "7%",
      "border-right": "none"
    }
  }, [_vm._v("Document No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.ebnData.details.docNo))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "7%",
      "border-right": "none"
    }
  }, [_vm._v("Document Date.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.ebnData.details.docDate))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "7%",
      "border-right": "none"
    }
  }, [_vm._v("Transaction Type:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.transactiontype))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "7%",
      "border-right": "none"
    }
  }, [_vm._v("Value of Goods:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.ebnData.details.totInvValue))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "7%",
      "border-right": "none"
    }
  }, [_vm._v("HSN Code:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.hsncode))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "7%",
      "border-right": "none"
    }
  }, [_vm._v("Reason For Transportation:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.supplytype) + " - " + _vm._s(_vm.subsupplytype))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "7%",
      "border-right": "none"
    }
  }, [_vm._v("Transporter:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.ebnData.details.transporterId) + " & " + _vm._s(_vm.ebnData.details.transporterName))])])])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%",
      "border-right": "none"
    }
  }, [_c('b', [_vm._v("e-Way Bill")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "width": "7%",
      "border-right": "none"
    }
  }, [_vm._v("IRN:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v("---------------------")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "width": "7%",
      "border-right": "none"
    }
  }, [_c('b', [_vm._v("PART-A")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61e00605","hasScoped":true}!./src/modules/report/views/EbnDetails/EbnDetails.component.html
// module id = 2079
// module chunks = 3